import { AppParamsActions } from './shared/store/app-params.reducer';
import { TraxPartnersActions } from './shared/store/traxpartners.reducer';
import { FullScreenStateActions } from './shared/store/full-screen.reducer';
import { IState } from './shared/store/root.reducer';
import { AuthService, User } from './shared/services/auth.service';
import {
  Component, ChangeDetectorRef, AfterViewInit, OnInit, OnDestroy, AfterViewChecked
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { correctHeight, detectBody } from './app.helper';
import { ToastrService } from 'ngx-toastr';
import { AppSettingsService } from './shared/services/app-settings.service';
import { RedirectService } from './shared/services/redirect.service';
import { VersionService } from './shared/services/version.service';
import { environment } from 'src/environments/environment';
import { AppActions } from './shared/store/app.reducer';
import { IConfigurationService } from './shared/services/configuration.service';
import { AppSettingActions } from './shared/store/app-settings.reducer';
import { IntegrationService } from './shared/services/integration.service';
import { DMSConnectState } from './shared/domain/dms-connect.entity';
import { SettingsService } from './shared/services/settings.service';
import { CurrentUserActions } from './shared/store/current-user.reducer';
import { PendoConfigurationService } from './shared/services/pendo-configuration.service';
import { PendoService } from './shared/services/pendo.service';
import { datadogRum } from '@datadog/browser-rum';
import {
  configureRumSDK, initializeRum, setRumUser, stopRumSession
} from 'ops-datadog-rum-core';

declare var jQuery: any;
declare global {
  interface Window {
    _walkmeConfig?: any;
    oecWalkmeVariables?: any;
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit, OnInit, OnDestroy, AfterViewChecked {
  currentUserKey = 'trax-partners.ops.id.currentUser';

  constructor(private router: Router,
    private authService: AuthService,
    public toastr: ToastrService,
    private store: Store<IState>,
    private cdRef: ChangeDetectorRef,
    private redirectService: RedirectService,
    private appSettingsService: AppSettingsService,
    private configurationService: IConfigurationService,
    public versionService: VersionService,
    public integrationService: IntegrationService,
    public settingsService: SettingsService,
    private pendoConfigurationService: PendoConfigurationService,
    private pendoService: PendoService,
  ) {
  }
  currentMode: string;
  topBarCssClass: string;
  mainBarCssClass: string;
  pageWrapperCssClass: string;
  tooltipCssClass: string;
  headerPageCssClass = '';
  position = '';
  // FullScreen Toggle btn
  public isFullscreen = false;
  private previousUrl: string;
  private currentUrl: string;
  subscriptions: Subscription = new Subscription();
  fontSizeClass = '';
  currentUser: User;
  alreadyProcceced = false;


  ngOnInit() {
    configureRumSDK(datadogRum as any);
    if (environment.datadogRum) {
      initializeRum({
        applicationId: environment.datadogRum.applicationId,
        clientToken: environment.datadogRum.clientToken,
        service: 'clplus-app-traxpartners-ux',
        env: environment.environment || 'unknown',
        sessionSampleRate: environment.datadogRum.sessionSampleRate,
        sessionReplaySampleRate: environment.datadogRum.sessionReplaySampleRate,
        defaultPrivacyLevel: environment.datadogRum.defaultPrivacyLevel,
      });
    }
    
    this.loadWalkmeScripts();
    // Run correctHeight function on load and resize window event
    jQuery(window).bind('load resize', function () {
      correctHeight();
      detectBody();
    });
    // add redux variable logged in, subscribe, if it change to false redirect to login screen
    // to prevent going to any page
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
        if (!this.alreadyProcceced) {
          if (!event.url.includes('login')) {
            this.authService.loadUserFromLocalStore();
          }
          this.proccessAppInit();
          this.alreadyProcceced = true;
        }

        if (this.previousUrl) {
          this.store.dispatch({
            type: AppParamsActions.SET_PREVIOUS_URL,
            payload: this.previousUrl
          });
        }
      }
    });
    this.versionService.get().subscribe(result => {
      let versionNumber = result.versionNumber;
      if (result.versionNumber && typeof result.versionNumber.substring === 'function') {
        versionNumber = versionNumber.substring(0, versionNumber.length - 2);
        this.store.dispatch({
          type: AppActions.SET_APP_VERSION,
          payload: versionNumber
        });
      }
    });

    window.addEventListener('storage', (event) => {
      let newUser = {} as User;
      if (event.key === this.currentUserKey && event.newValue !== null && event.newValue !== '') {
        newUser = JSON.parse(event.newValue) as User;
        if (this.currentUser && newUser && this.currentUser.contactId !== newUser.contactId) {
          window.alert('Old session expired. New user: ' + newUser.fullName);
          this.authService.loadUserFromLocalStore();
          stopRumSession();
        }
        setRumUser({
          id: newUser.id.toString(),
          name: newUser.fullName,
          username: newUser.userName,
        });
      }
    });
  }


  refreshApp() {
    const url = `${environment.baseUrl}#/partners`;
    window.location.href = url;
    window.location.reload();
  }

  private proccessAppInit() {
    this.redirectService.initialize();
    this.loadStore();
    this.authService.reloadSettings();
  }

  ngAfterViewInit() {
    // Correct height of wrapper after metisMenu animation.
    jQuery('.metismenu a').click(() => {
      setTimeout(() => {
        correctHeight();
      }, 300);
    });
  }

  loadStore() {
    this.subscriptions.add(
      this.store.pipe(select((state: IState) => state.fullScreen))
      .subscribe(fullScreenState => {
        this.topBarCssClass = fullScreenState.topBarCssClass;
        this.mainBarCssClass = fullScreenState.mainBarCssClass;
        this.pageWrapperCssClass = fullScreenState.pageWrapperCssClass;
        this.tooltipCssClass = fullScreenState.tooltipCssClass;
      })
    );

    this.subscriptions.add(
      this.store.pipe(select((state: IState) => state.print))
      .subscribe(printState => {
        this.headerPageCssClass = printState.headerPageCssClass;
      })
    );

    this.subscriptions.add(this.store.pipe(select((state: IState) => state.currentUser)).subscribe((currentUser) => {
      if ((currentUser && currentUser.contactId !== 0) || currentUser.isAnon) {
        this.currentUser = currentUser;
        if (this.currentUser.id) {
          this.getPendoInformation();
        }
        this.appSettingsService.GetApplicationNavigationAll({
          appId: +environment.appId,
          companyType: this.currentUser.userType,
          companyId: this.currentUser.companyId,
          userId: this.currentUser.id,
          encrypted: true
        }).subscribe(appNav => {
          this.store.dispatch({
            type: AppSettingActions.SET_APPLICATION_NAVIGATION,
            payload: appNav.map(x => x.applicationId)
          });
        });
        this.settingsService.isOEMSupplier().subscribe((supplierInfo) => {
          this.store.dispatch({
            type: CurrentUserActions.SET_OEM_SUPPLIER,
            payload: supplierInfo.isOEMSupplier
          });
        });

        this.integrationService.getDmsConnectSetting().subscribe(
          data => {
            this.store.dispatch({
              type: TraxPartnersActions.SET_DMS_CONNECT,
              payload: {
                isCustomerNumberEnabled: data.isCustomerNumberEnabled
              } as DMSConnectState
            });
        });
        
        setRumUser({
          id: currentUser.id.toString(),
          name: currentUser.fullName,
          username: currentUser.userName,
        });
      }
      
      this.setWalkMeVariables(currentUser);
    }));

    this.subscriptions.add(this.store.pipe(select((state: IState) => state.appSettings.IsLoaded)).subscribe(isLoadedSettings => {
      if (isLoadedSettings) {

        const temp = this.appSettingsService.getSetting('FontSize').value;
        if (temp) {
          this.setFontSizeClass(temp.toString());
        }
      }
    }));
  }

  getPendoInformation() {
      // Get Pendo Configuration
      this.configurationService.get().subscribe( pendoConfig => {
        if (pendoConfig) {
          this.currentUser.pendoApiKey = pendoConfig.pendoApiKey;
          this.currentUser.isTraxPartnersPendoEnabled = pendoConfig.traxPartnersPendoEnabled;
        }

      if (this.currentUser.isTraxPartnersPendoEnabled) {
        // load Pendo Script
        this.pendoConfigurationService.getUserPendoInfo().subscribe(pendoInfo => {
          if (pendoInfo) {
            this.currentUser.pendo = pendoInfo;
            this.pendoService.loadPendo(this.currentUser.pendoApiKey, this.currentUser);
          }
        });
      }
    });
  }


  fullScreenClick() {
    if (this.currentMode === 'INIT') {
      this.store.dispatch({
        type: FullScreenStateActions.SET_FULL_SCREEN_CONTENT,
      });
      this.currentMode = 'FULL';
    } else {
      this.store.dispatch({
        type: FullScreenStateActions.SET_INITIAL_CONTENT,
      });
      this.currentMode = 'INIT';
    }
  }

  setFontSizeClass(fontSize) {
    const div = document.getElementById('bodyinspinia');
    if (div) {
      div.setAttribute('style', 'font-size: ' + fontSize + 'px');
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  ngAfterViewChecked() {
    correctHeight();
    detectBody();
    this.cdRef.detectChanges();
  }

  private loadWalkmeScripts() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    // tslint:disable-next-line:quotemark max-line-length
    script.innerHTML = "(function() {var walkme = document.createElement('script'); walkme.type = 'text/javascript'; walkme.async = true; walkme.src = '" + environment.walkMeConfigUrl + "'; var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(walkme, s); window._walkmeConfig = {smartLoad:true}; window.oecWalkmeVariables = {}; })();";
    const head = document.getElementsByTagName('head')[0];
    if (head !== null && head !== undefined) {
      document.head.appendChild(script);
    }
  }

  setWalkMeVariables(currentUser) {
    if (window?.oecWalkmeVariables) {
      window.oecWalkmeVariables.opsInfo = {
        accountType: currentUser.userType === 1 ? 'Shop' : 'Supplier',
        opsTraxId: currentUser.contactId ? currentUser.contactId : '',
        companyId: currentUser.companyId ? currentUser.companyId : ''
      };
      window.oecWalkmeVariables.oecInfo = {
        oecCompanyId: currentUser.oecCompanyId
      };
      window.oecWalkmeVariables.userInfo = {
        roles: currentUser?.userRoles
      };
    }
  }
}

